import { get } from './commonFetch';

interface WaiverAirline {
  code: string;
}

const transform = (airline: any): WaiverAirline => {
  return {
    code: airline,
  };
};

export function getWaiverAirlines(): Promise<WaiverAirline[]> {
  return get<WaiverAirline[]>('/api/waivers/airlines').then(response => response.map(transform));
}
